import { v4 as uuidv4 } from 'uuid';
import { dataLayerPushServiceEvent } from '../../templates/components/pdp/utils/utils';
import { ServiceOffering } from '@jbhi-fi/apis/src/services/types';
import { updateCart, setCartLoading } from '../cart/cartUtils';
import { filterAndMapAttributes } from '@jbhi-fi/apis/src/utils/filterAndMapAttributes';
import { ShopifyStorefrontClient } from '../../api/shopify/ShopifyStorefrontClient';
import { JbCartItem } from '@jbhi-fi/apis/src/shopify/types/JbCart';

const storefrontClient = new ShopifyStorefrontClient();

export type AddServiceOffering = {
  variantId: number | string;
  location: string;
  serviceData: ServiceOffering;
  primaryLineItem: JbCartItem;
  shouldDrawCart?: boolean;
  message?: string | undefined;
};

export const addServiceOffering = async (input: AddServiceOffering) => {
  const {
    variantId,
    location,
    serviceData: serviceDataObject,
    primaryLineItem,
    shouldDrawCart = true,
    message,
  } = input;
  const { requiredServiceData, ...serviceData } = serviceDataObject;

  try {
    setCartLoading(true);
    const serviceLinkId = uuidv4();

    const primaryLineItemProperties = {
      ...primaryLineItem.properties,
      _isAttachedService: 'false',
      _serviceLink: serviceLinkId,
      _legacy_addons_line_key: serviceLinkId,
    };
    const serviceProperties = {
      _serviceLink: serviceLinkId,
      _isAttachedService: 'true',
      _serviceData: JSON.stringify(serviceData),
      _serviceSource: location,
      _requiredServiceData: JSON.stringify(requiredServiceData),
      _servicePrice: serviceData.priceInc.toString(),
      _serviceDate: serviceData.extraCareCoveragePeriod ?? `Issued by ${serviceData.vendorName}`,
      _legacy_addons_primary_line_key: serviceLinkId,
      _serviceType: serviceData.typeId,
      _priceRange: JSON.stringify(serviceData.priceRange),
    };

    await storefrontClient.updateCartLine(
      primaryLineItem.line_id,
      undefined,
      filterAndMapAttributes(primaryLineItemProperties)
    );

    const cart = await storefrontClient.addToCart(variantId, 1, filterAndMapAttributes(serviceProperties));

    if (shouldDrawCart) {
      await updateCart(cart);
    } else {
      setCartLoading(false);
    }

    dataLayerPushServiceEvent(
      `${serviceData.typeId}.addedtocart`,
      primaryLineItem?.onlineProduct?.ProductTags?.GoogleTagManager,
      {
        sku: serviceData.sku,
        name: serviceData.offeringName,
        price: serviceData.priceInc,
      },
      location,
      message
    );

    return cart;
  } catch (e) {
    window.console.error(e);
  }
};
